export default function AboutPage() {

    return <div class="aboutPage">
                <h2>About Scoped</h2><br></br>
                <p>Thanks to <a href="https://thetvdb.com/">TVDB</a> and <a href="https://www.treasuretv.org/">Treasure TV</a></p>
                <p><a href="https://iconscout.com/icons/search" target="_blank">Search icon</a> from <a href="https://iconscout.com/contributors/google-inc" target="_blank">Google Inc.</a></p>
                <p>Provide feedback <a href="https://forms.gle/AeLbnJRghtrwXErJA">here</a></p>
            </div>;
}